import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Grid } from '@material-ui/core';
import { Button } from '~/elements';
import TextFieldGoogleAutocomplete from '~/components/TextFieldGoogleAutocomplete';
import { loadCategoriasRequest } from '~/store/modules/categorias/actions';
import {
  updateField,
  setTipoIndicacao,
  searchEndereco,
} from '~/store/modules/indicacao/actions';
import useMapsScript from '~/hooks/useMapsScript';

const Form = styled.form.attrs({
  className: 'row',
  id: 'form-busca-endereco',
})``;

const ContainerButton = styled.div`
  margin-top: 15px;
  display: flex;
  justify-content: flex-end;
`;

export default function FormBuscaEndereco({ debounce }) {
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const history = useHistory();
  const [isValid, setIsValid] = useState(false);
  const [messageError, setMessageError] = useState('');
  const [endereco, setEndereco] = useState({});
  useMapsScript();

  const handleChangeText = useCallback(
    ({ target }) => {
      dispatch(updateField('nomeFantasia', target.value));
      setIsValid(target.value.length > 0);
    },
    [dispatch],
  );

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.addEventListener('keyup', handleChangeText, false);
    }

    const element = inputRef.current;
    return () => {
      if (element) {
        element.removeEventListener('keyup', handleChangeText, false);
      }
    };
  }, [inputRef, handleChangeText]);

  useEffect(() => {
    dispatch(setTipoIndicacao('endereco'));
  }, [dispatch]);

  const handleSubmit = useCallback(
    e => {
      e.preventDefault();
      if (Object.keys(endereco).length > 0) {
        dispatch(searchEndereco(endereco));
      } else {
        dispatch(loadCategoriasRequest());
      }

      history.push('/indique/formulario');
    },
    [dispatch, endereco, history],
  );

  function handleOnSelect(location) {
    try {
      const {
        endereco: enderecoGoogle,
        numero,
        bairro,
        estado,
        cidade,
        cep,
        nomeFantasia,
        latitude,
        longitude,
        success,
        telefone,
      } = location;

      if (!success) {
        throw new Error('Erro ao buscar o endereço!');
      }

      setEndereco({
        endereco: enderecoGoogle,
        numero,
        bairro,
        estado,
        cidade,
        cep,
        nomeFantasia,
        latitude,
        longitude,
        telefone,
      });

      setIsValid(true);
      setMessageError('');
    } catch (e) {
      setIsValid(false);
      setMessageError('O endereço selecionado é inválido!');
    }
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Grid cols="12 12 12 5">
        <TextFieldGoogleAutocomplete
          ref={inputRef}
          name="endereco"
          label="Nome ou endereço do estabelecimento"
          messageError={messageError}
          debounce={debounce}
          onSelect={handleOnSelect}
          required
        />
      </Grid>
      <Grid cols="12 12 12 4" className="offset-lg-8">
        <ContainerButton>
          <Button
            label="Continuar"
            type="submit"
            variant="contained"
            disabled={!isValid}
          />
        </ContainerButton>
      </Grid>
    </Form>
  );
}

FormBuscaEndereco.propTypes = {
  debounce: PropTypes.number,
};

FormBuscaEndereco.defaultProps = {
  debounce: 500,
};
